/* tslint:disable:typedef */

import autoBind from 'auto-bind'

/**
 * BaseClass for Router files in REST APIs
 *
 * @class
 * @classdesc BaseClass for Router files in REST APIs
 */
export abstract class BaseResolver {
  //
  // public static errJson(
  //   res: Response, code: number = 200, message: string
  // ): any {
  //   return res.status(code).json({message})
  // }

  constructor() {
    autoBind(this)
  }

  /**
   * @param {Object} app - app context
   */
  // constructor(app: any) {
  //   this.app = app;
  // }

  public resolvers(): any {
    throw new Error(`${this.constructor.name}.mapRoutes is not implemented`)
  }

  protected applyMiddlewares(
    handlers: Array<(...args) => any> = [],
    resolvers: { [key: string]: (...args) => any } = {},
    postHandlers: Array<(...args) => any> = []
  ) {
    if (!handlers) {
      return resolvers
    }
    for (const [name, resolver] of Object.entries(resolvers)) {
      resolvers[name] = async (...args) => {
        try {
          for (const handler of handlers) {
            await handler(...args)
          }
          const result = await resolver(...args)
          if (postHandlers) {
            for (const handler of postHandlers) {
              await handler(result, ...args)
            }
          }
          return result
        } catch (e) {
          throw e
        }
      }
    }
    return resolvers
  }
}
